import {
	getCookies,
	realityCheckControl,
	realityCheckPopupAcknowledgedTime,
	realityCheckPopupAcknowledgementId,
	realityCheckId,
	setCookie
} from '~/store/cookies.js';
import { requestApi } from '~/services/api.js';
import { fetchJson } from '~/core/ajax-json.js';

// TODO: cleanup after new refactored UI is toggled ON
export const getTexts = ({
	texts: {
		popupHeader = '',
		playedTime = '',
		betSumHeader = '',
		messageUpper = '',
		hours = '',
		minutes = '',
		closeAndReset = '',
		closeAndDisable = '',
		historyButton = '',
		logout = '',
		historyTitle = '',
		historyLink = '',
		historyCloseButton = '',
		balanceText = ''
	},
	totalWagered = '',
	playTimeHours,
	playTimeMinutes,
	betSum = ''
}) => {
	let playTime = '';
	if (playTimeMinutes > 0 || playTimeHours > 0) playTime = `${playTimeHours} ${hours}, ${playTimeMinutes} ${minutes}`;
	return {
		MOBILE_REALITY_CHECK_HEADER: popupHeader,
		MOBILE_REALITY_CHECK_TIME_PLAYED_HEADER: playedTime,
		MOBILE_REALITY_CHECK_BET_SUM_HEADER: betSumHeader,
		MOBILE_REALITY_CHECK_MESSAGE_UPPER: messageUpper,
		MOBILE_REALITY_CHECK_PLAY_TIME: playTime,
		MOBILE_REALITY_CHECK_BET_SUM: betSum,
		MOBILE_REALITY_CHECK_TOTAL_WAGERED: totalWagered,
		MOBILE_REALITY_CHECK_BET_SUM_TEXT: balanceText,
		MOBILE_REALITY_CHECK_CONTINUE_BUTTON: closeAndReset,
		MOBILE_REALITY_CHECK_DISABLE_BUTTON: closeAndDisable,
		MOBILE_REALITY_CHECK_HISTORY_BUTTON: historyButton,
		MOBILE_REALITY_CHECK_LOGOUT_BUTTON: logout,
		MOBILE_REALITY_CHECK_HISTORY_TITLE: historyTitle,
		MOBILE_REALITY_CHECK_HISTORY_LINK: historyLink,
		MOBILE_REALITY_CHECK_HISTORY_CLOSE_BUTTON: historyCloseButton
	};
};

export const getRCWebSocketTexts = ({
	translations,
	playTimeHours,
	playTimeMinutes,
	betSum = '',
	totalWagered = '',
	realityCheckNotLosing = undefined
}) => {
	let playTime = '';
	if (playTimeMinutes > 0 || playTimeHours > 0)
		playTime = `${playTimeHours} ${
			playTimeHours === 1 ? translations.REALITY_CHECK_HOUR : translations.REALITY_CHECK_HOURS
		}, ${playTimeMinutes} ${translations.REALITY_CHECK_MINUTES}`;
	return {
		...translations,
		betSum,
		playedTime: translations.REALITY_CHECK_PLAYED_TIME,
		MOBILE_REALITY_CHECK_TIME_PLAYED_HEADER: translations.REALITY_CHECK_PLAYED_TIME,
		MOBILE_REALITY_CHECK_PLAY_TIME: playTime,
		MOBILE_REALITY_CHECK_BET_SUM: betSum,
		MOBILE_REALITY_CHECK_TOTAL_WAGERED: totalWagered,
		MOBILE_REALITY_CHECK_BET_SUM_TEXT: realityCheckNotLosing
			? translations.REALITY_CHECK_WON
			: translations.REALITY_CHECK_LOST,
		MOBILE_REALITY_CHECK_CONTINUE_BUTTON: translations.MOBILE_REALITY_CHECK_BUTTON_CONTINUE,
		MOBILE_REALITY_CHECK_DISABLE_BUTTON: translations.MOBILE_REALITY_CHECK_BUTTON_DISABLE,
		MOBILE_REALITY_CHECK_LOGOUT_BUTTON: translations.MOBILE_REALITY_CHECK_BUTTON_LOGOUT
	};
};

export const getTimestamp = () => parseInt(realityCheckControl(), 10);
export const getPopupAcknowledgedTimestamp = () => parseInt(realityCheckPopupAcknowledgedTime(), 10);
export const getPopupAcknowledgementId = () => parseInt(realityCheckPopupAcknowledgementId(), 10);
export const getRCId = () => parseInt(realityCheckId(), 10);
export const isRCAccepted = () => getCookies('RCAccepted') === 'accepted';
export const getRCAFromCookies = () => getCookies('RCAccepted');
export const setRCACookie = value => setCookie('RCAccepted', value);

export const setTimestamp = async () => requestApi('/player/limits/reality-check', {}, 'PUT');
export const setAcknowledgementTimestamp = async (confirmed, decline = false) =>
	requestApi(
		`/player/limits/reality-check/acknowledgement?confirmed=${confirmed}&decline=${decline}${
			confirmed ? `&id=${getPopupAcknowledgementId()}` : ''
		}`,
		{},
		'POST'
	);

export const setGermanRCAcknowledgement = async (acknowledged = false) =>
	requestApi(
		`/player/limits/reality-check/popup-acknowledgement?id=${realityCheckId()}&acknowledged=${acknowledged}`,
		{},
		'POST'
	);

export const germanPopUpShown = async () =>
	requestApi(`/player/limits/reality-check/popup-view?id=${realityCheckId()}`, {}, 'POST');

export const getCurrentDate = async () => {
	try {
		const response = await fetchJson('/player/limits/reality-check/date');
		return response?.result?.date ?? Date.now();
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Error getting server timestamp, using system date instead');
		return Date.now();
	}
};

export const getPopupInfo = async () => requestApi('/player/limits/reality-check/popup');

export const getCoolOff = async () => requestApi('/cooloff/client/rc-cooloff');

export const postCoolOff = async payload => requestApi('/cooloff/client/rc-cooloff', payload, 'POST');
